import axios from 'axios';
import  { BACKEND_URL } from './Backend';

//const API_URL = 'http://localhost:8080'

export const USER_NAME_SESSION_ATTRIBUTE_NAME = 'authenticatedUserName';
export const USER_SESSION_ATTRIBUTE = 'authenticatedUser';
export const USER_SESSION_ROLES = 'authenticatedRoles';
export const USER_DEMO = 'userDemo';


class AuthenticationService {

    executeBasicAuthenticationService(username, password) {
        return axios.get(`${BACKEND_URL}/basicauth`,
            { headers: { authorization: this.createBasicAuthToken(username, password) } })
    }

    executeJwtAuthenticationService(username, password) {
        return axios.post(`${BACKEND_URL}authenticate`, {
            username,
            password
        })
    }

    createBasicAuthToken(username, password) {
        return 'Basic ' + window.btoa(username + ":" + password)
    }

    registerSuccessfulLogin(username, password) {
        //let basicAuthHeader = 'Basic ' +  window.btoa(username + ":" + password)
        //console.log('registerSuccessfulLogin')
        sessionStorage.setItem(USER_NAME_SESSION_ATTRIBUTE_NAME, username)
        this.setupAxiosInterceptors(this.createBasicAuthToken(username, password))
    }

    registerSuccessfulLoginForJwt(username, token, loggedUser) {
        sessionStorage.setItem(USER_NAME_SESSION_ATTRIBUTE_NAME, username);
        sessionStorage.setItem(USER_SESSION_ATTRIBUTE, JSON.stringify(loggedUser));
        this.setupAxiosInterceptors(this.createJWTToken(token))
    }
    
    registerUserDemo(input){
        if(input && input === 'eE432'){
            sessionStorage.setItem(USER_DEMO, true);
            return true;
        }
        return false;
    }

    createJWTToken(token) {
        return 'Bearer ' + token
    }


    logout() {
        sessionStorage.removeItem(USER_NAME_SESSION_ATTRIBUTE_NAME);
        sessionStorage.removeItem(USER_SESSION_ATTRIBUTE);
        sessionStorage.removeItem(USER_SESSION_ROLES);
    }

    isUserLoggedIn() {
        let user = sessionStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME)
        if (user === null) return false
        return true
    }

    
    isUserInAdminRole() {
        return sessionStorage.getItem(USER_SESSION_ROLES) && sessionStorage.getItem(USER_SESSION_ROLES).includes('ADMIN');
    }

    isUserInDemoRole() {
        return sessionStorage.getItem(USER_DEMO) ;
    }

    

    getLoggedInUserName() {
        let user = sessionStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME)
        if (user === null) return ''
        return user
    }

    getLoggedUser() {
        let userValue =  sessionStorage.getItem(USER_SESSION_ATTRIBUTE);
        if(userValue){
            return JSON.parse(userValue);
        }
        return null;
    }

    setupAxiosInterceptors(token) {
        axios.interceptors.request.use(
            (config) => {
                if (this.isUserLoggedIn()) {
                    config.headers.authorization = token
                }
                return config
            }
        )
    }
}

export default new AuthenticationService();